<template>
  <div class="content">
    <el-row class="title">
      <span class="title-p">{{videoInfo.title}}</span>

    </el-row>
    <el-row>
      <span class="f10 content-time">{{videoInfo.uploadTime}}</span>
    </el-row>
    <article class="article" v-html="videoInfo.content"></article>
    <el-row class="right">
      <el-col :span="2" class="no-click">
        <el-tooltip class="item" effect="dark" content="点击下载，建议使用word打开。" placement="bottom">
          <el-button type="success" icon="el-icon-download" circle @click="download"  ></el-button>
        </el-tooltip>

      </el-col>
      <el-col :span="2">
        <el-link :underline="false" v-bind:class="{fonthove:fontColor,likeColor:isLikeColor}" @click="like">
          <span class="iconfont">&#xec8c;</span>
          <span>{{videoInfo.countLike}}</span>
        </el-link>

      </el-col>
      <el-col :span="2" class="no-click">
        <span class="iconfont">&#xe7cd;</span>
        <span>{{videoInfo.countPlay}}</span>
      </el-col>


    </el-row>

    <div class="comment-area">
      <div>
        <span class="comment-num">{{commentNum}}&nbsp;评论</span>
      </div>
      <el-tabs v-model="defaultSort" >
        <el-tab-pane label="按热度排序" name="heat"><comment  v-bind:id="this.id" v-bind:order="this.sortHeat"></comment></el-tab-pane>
        <el-tab-pane label="按时间排序" name="time"><comment v-bind:id="this.id" v-bind:order="this.sortTime"></comment></el-tab-pane>
      </el-tabs>

    </div>
  </div>



</template>

<script>
  import { updatePlay,verifyVideoInfo,addLike} from '@/api/videoDetail'
  import comment from '@/components/comments/index'
  import { downloadFile } from '@/api/article'
  import { parseTime, formatTimes } from '@/utils/index'

    export default {

      name: "article",
      components: {comment},
      props:[
        'id'
      ],
      data() {
        return {
          data: {
          },
          defaultSort: 'heat',
          titleSearch: null,
          commentData: [],
          videoInfo:{},
          commentNum:'',
          sortTime:'time',
          sortHeat:'heat',
          fontColor:true,
          isLikeColor:false,
          avatar:''
        }
      },
      created() {
        this.verifyVideo(this.id)
      },
      methods:{
        download(){
          // window.location.href=this.baseBackUrl+"article/download?access_token="+getToken();
          downloadFile(this.id).then( res => {
            debugger
            // if(res.code === 20000){
              let blob = new Blob([res], {type: res.type})
              let downloadElement = document.createElement('a')
              let href = window.URL.createObjectURL(blob); //创建下载的链接
              downloadElement.href = href;
              downloadElement.download = this.videoInfo.title+'.docx'; //下载后文件名
              // downloadElement.download = videoInfo.title+'kaiy.docx'; //下载后文件名
              document.body.appendChild(downloadElement);
              downloadElement.click(); //点击下载
              document.body.removeChild(downloadElement); //下载完成移除元素
              window.URL.revokeObjectURL(href); //释放blob对象
            // }
          })
        },

        verifyVideo(id){
          verifyVideoInfo(id).then(res=>{
            if (res.code === 20000){
              if(res.data!==0){

                res.data.video.uploadTime =parseTime(res.data.video.uploadTime,"{y}-{m}-{d} {h}:{i}:{s}")
                this.videoInfo = res.data.video
                this.avatar=this.baseUrl+res.data.video.userAvatar
                this.commentNum = res.data.commentAndReplyNum
                this.updatePalyl(id)
              }
            }
          })
        },
        updatePalyl(id){
          updatePlay(id).then(res=>{
           })
        },
        like(){
          if(this.isLikeColor===true){
            this.$message({
              message:"您已经点过了哦",
              type:"info"
            })
          }else{
            addLike(this.id).then(res=>{
              if (res.code===20000){
                this.$message({
                  message:res.message,
                  type:"success"
                })
                this.verifyVideo(this.id)
                this.fontColor=false
                this.isLikeColor=true
              }
            })
          }
        }
      }
    }
</script>

<style scoped>
  @import "../../assets/icon/iconvideo/iconfont.css";
  @import "../../assets/icon/iconfont.css";
  .content{
    width: 1200px;
    margin: auto;
  }
  .title-p{
    font-size: 18px;
    font-weight: 600;
  }
  .title{
    margin-top: 16px;
    margin-bottom: 0px;
  }
  .content-time{
    font: inherit;
    color: #9B9B9B;
    font-size: 12px;
  }
  .article{
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .fonthove:hover{
    color: #00b5e5 !important;
  }
  .likeColor{
    color: #00b5e5 !important;
  }
  .fonthove {
    color:#757575 !important;
  }
  .no-click{
    color:#757575 !important;
  }
  .el-col{
    float: right;
  }
  .iconfont{
    font-size: 25px;
  }
  .el-button.is-circle{
    padding: 5px;
    margin-top: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/views/article/article.vue